import { get, set } from 'idb-keyval'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { addMapView } from 'map-viewer'
import { MapData } from '~map-preview/types/__generated/gql/graphql'

import { setIsMapSaved, setMapData } from '~map-preview/states/map'

export const useInitMapData = (mapId: string, initialMapData?: MapData) => {
  const dispatch = useDispatch()

  useEffect(() => {
    const getMapData = async () => {
      const cachedMapData = await get(mapId)

      dispatch(setMapData(initialMapData ?? cachedMapData))

      if (initialMapData) {
        dispatch(setIsMapSaved(true))
        await set(mapId, initialMapData)
      }

      // INFO: increase map view count
      await addMapView(mapId)
    }

    mapId && getMapData()
  }, [dispatch, mapId, initialMapData])
}
